import styled, { css } from 'styled-components';

import { PartialBy } from '~src/types';

import {
  BaseButton,
  ButtonColorTypes,
  ButtonProps,
  ButtonShape,
  ButtonSizes,
  buttonColors,
  buttonFontColors,
} from './BaseButton.sc';

const PrimaryButton = styled(BaseButton)<
  PartialBy<ButtonProps, '$buttonColor' | '$buttonSize'>
>`
  ${({ $buttonColor = ButtonColorTypes.Blue, $withBorder, theme, $buttonShape = ButtonShape.Oval }) => css`
    background-color: ${buttonColors[$buttonColor]};
    color: ${buttonFontColors[$buttonColor]};
    position: relative;
    border: ${$withBorder ? `1px solid ${theme.white.a6}` : 0};

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: ${theme.white.a10};
      border-radius: ${$buttonShape === ButtonShape.Rectangle ? '5px' : '50px'};
      opacity: 0;
      transition: opacity 0.5s ease-out;
    }

    &:hover:not(:disabled) {
      &::before {
        opacity: 0.15;
      }
    }
  `}
`;

PrimaryButton.defaultProps = {
  $buttonColor: ButtonColorTypes.Blue,
  $buttonSize: ButtonSizes.Medium,
};

export default PrimaryButton;
